function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPause = function SvgPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    viewBox: "0 0 512 512",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.584 0h186.6v512h-186.6zM294.816 0h186.6v512h-186.6z",
    style: {
      fill: "#e21b1b"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };